require('../../modules/es6.string.repeat');
module.exports = require('../../modules/_core').String.repeat;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/repeat.js
// module id = 234
// module chunks = 0